import { styled } from '@mui/material';

import { Skeleton } from '@app-velocity/ui';

const StyledPage = styled('div')(({ theme }) => ({
  padding: theme.spacing(3),
}));

export const NewReviewSkeleton = () => (
  <StyledPage>
    <Skeleton width={120} height={14} />
    <Skeleton width={300} height={29} />
    <Skeleton height={196} />
    <Skeleton height={20} />
    <Skeleton height={35} />
    <Skeleton height={20} />
    <Skeleton height={84} />
    <Skeleton height={84} />
  </StyledPage>
);
